<login-alt-layout pageTitle="Contact Help Desk">
  <div class="row">
    <div class="col-9">
      <h2 class="harp-title mb-4">How Can We Help?</h2>

      <h4 class="mb-4">
        CCSQ QualityNet has a large support community. Select a topic below to
        find the Help Desk that can best assist you.
      </h4>

      <form [formGroup]="contactForm" class="mb-4">
        <!-- Topic Input -->
        <div class="row">
          <div class="col-lg-5 col-md-6 mb-3">
            <harp-input [inputConfig]="topicInput"></harp-input>
          </div>
        </div>

        <!-- Subtopic Input -->
        <div class="row">
          <div class="col-lg-5 col-md-6">
            <harp-input [inputConfig]="subtopicInput"></harp-input>
          </div>
        </div>
      </form>

      <ng-container *ngIf="config">
        <!-- Header Text -->
        <div
          class="header-text"
          *ngIf="config.headerText"
          [innerHtml]="config.headerText"
        ></div>
        <hr />

        <!-- Links Followed by Arrows -->
        <app-arrow-links
          *ngIf="config.links"
          [links]="config.links"
        ></app-arrow-links>
        <hr />

        <!-- Contact Details -->
        <app-contact-details
          *ngIf="config.contactDetails"
          id="test-identity-proofing-contact-container"
          [config]="config.contactDetails"
        ></app-contact-details>

        <!-- Custom Contact Details -->
        <div
          *ngIf="config.customContactDetails"
          [innerHtml]="config.customContactDetails"
        ></div>
        <hr />

        <!-- Footer Text -->
        <h4 *ngIf="config.footerText">
          <div [innerHtml]="config.footerText"></div>
        </h4>
      </ng-container>

      <!-- Default Footer Text -->
      <div
        *ngIf="!config?.footerText"
        id="test-ccsq-support-ticket-submit-container"
      >
        To submit and track a help ticket, visit
        <a
          href="https://cmsqualitysupport.servicenowservices.com/ccsq_support_central"
          target="_blank"
        >
          CCSQ Support Central</a
        >.
      </div>
    </div>
  </div>
</login-alt-layout>
